import React, { useEffect, useState } from "react";
import { Page } from "../../components/Page";
import {
  deleteRoomRatePlan,
  getCurrentUser,
  getRoomRatePlan,
  getRoomType,
} from "../../api-config/config";
// import RoomRatePlanType from "../../components/RoomRatePlan";
import NewRoomRatePlanType from "../../components/RoomRatePlan/NewRoomRatePlan";
import SimpleTable from "../../components/table/SimpleTable";
import SnackBar from "../../components/SnackBar/SnackBar";
import LoaderWrapper from "../../components/LoaderWrapper/LoaderWrapper";

function RoomRatePlanListGrid(props: any) {
  const { row, roomTypeAdded, roomTypes, setLoading } = props;

  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [roomTypeData, setRoomTypeData] = useState<any>({});

  const [snackbar, setSnackbar] = useState({
    visible: false,
    message: "",
    type: "success" as "success" | "error",
  });

  const showSnackbar = (message: string, type: "success" | "error") => {
    setSnackbar({ visible: true, message, type });
  };

  const handleSuccess = (message: string) => {
    showSnackbar(message, "success");
    setOpen(false);
    setRoomTypeData({});
  };

  const onEditClick = (rowData: any) => {
    setRoomTypeData(rowData);
    setOpen(true);
  };

  const onDeleteClick = (rowData: any) => {
    setRoomTypeData(rowData);
    setDeleteOpen(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await deleteRoomRatePlan({ id: roomTypeData.rate_plan_id });
      showSnackbar("Rate plan deleted successfully", "success");
      setDeleteOpen(false);
      setRoomTypeData({});
      roomTypeAdded();
    } catch {
      setLoading(false);
      showSnackbar("Failed to delete rate plan", "error");
    }
  };

  const columns = [
    { header: "#", accessor: "serial", width: "5%" },
    { header: "Room Type", accessor: "roomtype", width: "20%" },
    { header: "Plan Name", accessor: "planname", width: "15%" },
    { header: "Included", accessor: "included", width: "20%" },
    { header: "Amount", accessor: "amount", width: "10%" },
    {
      header: "Actions",
      accessor: "actions",
      width: "10%",
      render: (_: any, row: any) => (
        <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
          {/* Edit */}
          <span style={{ cursor: "pointer" }} onClick={() => onEditClick(row)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
            </svg>
          </span>

          {/* Delete */}
          <span style={{ cursor: "pointer" }} onClick={() => onDeleteClick(row)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 30 30"
              fill="red"
            >
              <path d="M 14.984375 2.4863281 A 1.0001 1.0001 0 0 0 14 3.5 L 14 4 L 8.5 4 A 1.0001 1.0001 0 0 0 7.4863281 5 L 6 5 A 1.0001 1.0001 0 1 0 6 7 L 24 7 A 1.0001 1.0001 0 1 0 24 5 L 22.513672 5 A 1.0001 1.0001 0 0 0 21.5 4 L 16 4 L 16 3.5 A 1.0001 1.0001 0 0 0 14.984375 2.4863281 z M 6 9 L 7.7929688 24.234375 C 7.9109687 25.241375 8.7633438 26 9.7773438 26 L 20.222656 26 C 21.236656 26 22.088031 25.241375 22.207031 24.234375 L 24 9 L 6 9 z" />
            </svg>
          </span>
        </div>
      ),
    },
  ];

  const rows =
    row?.map((item: any, index: number) => ({
      serial: index + 1,
      rate_plan_id: item.id,
      roomtype: item.room_type_name,
      planname: item.name,
      included: item.included || "N/A",
      amount: item.rate_amount,
      description: item.description || "N/A",
      room_type_id: item.room_type_id,
    })) || [];

  return (
    <div style={{ width: "100%" }}>
      {/* Header */}
      <div className="roomtype-header">
        <h2 className="roomtype-title">Room Rate Plan List</h2>
        <div className="roomtype-btns">
          <button
            className="my-custom-btn"
            onClick={() => {
              setRoomTypeData({});
              setOpen(true);
            }}
          >
            Add Rate Plan
          </button>
        </div>
      </div>

      <SimpleTable columns={columns} data={rows} />

      {/* Add/Edit Modal */}
      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3 className="modal-title">Room Rate Plan</h3>
            </div>
            <div className="modal-content">
              <NewRoomRatePlanType
              // {/* <RoomRatePlanType */}
                handleClose={() => setOpen(false)}
                onRoomTypeAdded={roomTypeAdded}
                roomTypeData={roomTypeData}
                roomTypes={roomTypes}
                onSuccess={handleSuccess}
                setLoading={setLoading}
              />
            </div>
          </div>
        </div>
      )}

      {/* Delete Modal */}
      {deleteOpen && (
        <div className="delete-modal-overlay" onClick={() => setDeleteOpen(false)} >
          <div className="delete-modal-box" onClick={(e) => e.stopPropagation()} >
            <h3 className="delete-modal-title">
              Are you sure you want to delete?
            </h3>

            <p className="delete-modal-desc">
              Room Rate Plan{" "}
              <span> {roomTypeData.roomtype} - {roomTypeData.planname} </span>{" "}
              will be permanently removed.
            </p>

            <div className="delete-modal-actions">
              <button className="delete-btn-cancel" onClick={() => setDeleteOpen(false)} >
                No
              </button>

              <button className="delete-btn-confirm" onClick={handleDelete} >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}


      <SnackBar
        visible={snackbar.visible}
        message={snackbar.message}
        type={snackbar.type}
        onClose={() => setSnackbar((s) => ({ ...s, visible: false }))}
      />
    </div>
  );
}

export default function NewRoomsRatePlan() {
  const [ratePlans, setRatePlans] = useState<any[]>([]);
  const [roomTypes, setRoomTypes] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const loggedUser = getCurrentUser();

  const load = () => {
    setLoading(true);
    getRoomRatePlan({ hotel_code: loggedUser?.hotel_code }).then(
      (res: any) => {
        if (res?.status_message === "success") setRatePlans(res.data || []);
        setLoading(false);
      },
      (error: any) => {
        console.log("error", error);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([
      getRoomRatePlan({ hotel_code: loggedUser?.hotel_code }),
      getRoomType(loggedUser?.hotel_code)
    ]).then(
      ([ratePlanRes, roomTypeRes]: any) => {
        if (ratePlanRes?.status_message === "success") {
          setRatePlans(ratePlanRes.data || []);
        }
        if (roomTypeRes?.status_message === "success") {
          setRoomTypes(roomTypeRes.data || []);
        }
        setLoading(false);
      },
      (error: any) => {
        console.log("error", error);
        setLoading(false);
      }
    );
  }, []);

  return (
    <Page title="Home">
      {loading && <LoaderWrapper />}
      <div style={{ padding: "0 20px" }}>
        <RoomRatePlanListGrid
          row={ratePlans}
          roomTypeAdded={load}
          roomTypes={roomTypes}
          setLoading={setLoading}
        />
      </div>
    </Page>
  );
}